import { DataBag } from '../store/selectors';
import { ProjectState } from './project.reducer';

export const ProjectFeature = 'Project';
export const selectProjectFeature = (state: DataBag) =>
  state[ProjectFeature] as ProjectState;
